//  ANGULAR ----------------------------------------------
import { Component, inject, OnInit } from "@angular/core";
import { NgClass } from "@angular/common";

// PRIME NG ----------------------------------------------
import { TieredMenuModule } from "primeng/tieredmenu";
import { MenuItem } from "primeng/api";

//  CUSTOM -----------------------------------------------
import { OidcSecurityService } from "angular-auth-oidc-client";
import { GlobalService } from "@shared/services";
import { ThemeService } from "@core/services/theme.service";

@Component({
  selector: "app-navbar",
  standalone: true,
  imports: [NgClass, TieredMenuModule],
  templateUrl: "./navbar.component.html",
  styleUrl: "./navbar.component.scss",
})
export class NavbarComponent implements OnInit {
  oidcService = inject(OidcSecurityService);
  globalService = inject(GlobalService);
  themeService = inject(ThemeService);

  user: string = "Hello, User!";

  items: MenuItem[] | undefined;

  ngOnInit(): void {
    this.items = [
      {
        label: "Theme",
        icon: "pi pi-moon",
        command: () => {
          this.toggleTheme();
        },
      },
      {
        label: "Sign Out",
        icon: "pi pi-sign-out",
        command: () => {
          this.logout();
        },
      },
    ];
  }

  toggleTheme() {
    const currentTheme = localStorage.getItem("theme");
    if (currentTheme) {
      if (currentTheme === "dark") {
        this.themeService.applyTheme("light");
        return;
      }
      this.themeService.applyTheme("dark");
      return;
    }
    this.themeService.applyTheme("dark");
  }

  logout(): void {
    this.oidcService.logoff().subscribe();
  }
}
